import * as React from "react";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";
import { externalgetApi } from "../../services/external/externalApis";
import { COMMON_API_02 } from "../../api/ApiModel";
import { useSelector } from "react-redux";
import BarcodeGenerator from "./Barcode";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import SearchAppBar from "../../components/common/search";

function ViewBarcode() {
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedMenuName, setSelectedMenuName] = useState("");
  const [selectedMenucode, setSelectedMenucode] = useState("");
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  const goToHomePage = () => {
    navigate("/");
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchText(value);

    if (value) {
      const filtered = data.filter((card) =>
        card.MENUNAME.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(COMMON_API_02, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setFilteredData(result);
      } catch (err) {
        setError(err);
      }
    };

    fetchData();
  }, [COMPCODE, LOCCODE, RESTCODE]);

  const handleCardClick = (menuname, menucode) => {
    setSelectedMenuName(menuname);
    setSelectedMenucode(menucode);
  };

  return (
    <div>
      <Navbar />
      <AppBar position="static" sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1} py={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none" onClick={goToHomePage}>
                  Home
                </Link>
                <Link underline="none" href="#">
                  Stock
                </Link>
                <Typography color="text.primary">Add Stock</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction="row" justifyContent="flex-end" spacing={2}>
                <Button
                  onClick={goToHomePage}
                  variant="contained"
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "1px",
                    width: "80px",
                  }}
                >
                  Back
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      <Box ml={12} p={2}>
        <Grid container spacing={2} mt={13}>
          <Grid item xs={12} md={8}>
            <Box
              sx={{
                background: theme.palette.background.default,
                p: 2,
                borderRadius: "4px",
                boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
              }}
            >
              <SearchAppBar onChange={handleSearchChange} value={searchText} />
              <Grid container sx={styles.BR_box} spacing={2} m={2}>
                {filteredData.length > 0 ? (
                  filteredData.map((card) => (
                    <Grid item xs={12} sm={6} md={2} key={card.id}>
                      <Card
                        sx={styles.ks_card}
                        onClick={() =>
                          handleCardClick(card.MENUNAME, card.MENUCODE)
                        }
                      >
                        <CardMedia
                          component="img"
                          height="140"
                          image={card.IMAGEPATH}
                          alt={card.MENUNAME}
                          sx={styles.br_card_media}
                        />
                        <CardContent>
                          <Typography variant="h6" component="div">
                            {card.MENUNAME}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <Typography variant="body1" sx={{ pl: 2 }}>
                    No data available.
                  </Typography>
                )}
              </Grid>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <BarcodeGenerator
              selectedMenuName={selectedMenuName}
              selectedMenucode={selectedMenucode}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default ViewBarcode;
